import styled from 'styled-components';
import { rhythm } from '../../utils/typography'

const Wrapper = styled.div`    
    margin-bottom: ${rhythm(1)};
    
    & h3{
        margin: 0 0 ${rhythm(0.6)} 0;
    }

    & p{
        margin: 0;
    }
`;

export default Wrapper;


// WEBPACK FOOTER //
// ./src/components/PostSummary/Wrapper.js